// extracted by mini-css-extract-plugin
module.exports = {"hideCancel":"modal_hideCancel__1INIL","blueColor":"modal_blueColor__3sJ2K","revertButton":"modal_revertButton__2pPsW"};